<template>
  <div class="pt-1">
    <v-card>
      <v-card-title class="pb-0 mx-auto">
        <v-card-text class="pa-0">
          <p class="text-xs-center">
            {{ data.descripcion }}
          </p>
        </v-card-text>
      </v-card-title>

      <v-card-text>
        <p class="caption">
          <ResumenItinerario :resumen="data.ida" />
          <ResumenItinerario :resumen="data.vuelta" />
          Adultos {{ data.totales.adl }}
          <span v-if="data.totales.chd != 0">Menores {{ data.totales.chd }}</span>
          <span class="float-right font-weight-light"> {{ data.totales.moneda }} {{ data.totales.venta }} </span>
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ResumenItinerario from "@/components/cupos/ResumenItinerario.vue"
export default {
  name: "carritoPanelCupo",
  props: ["data"],
  components: {
    ResumenItinerario
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {}
}
</script>
<style scoped>
.hover-hab-as:hover {
  background-color: #eceff1;
}
</style>
